<template>
  <div id="privilege-info">
    <div class="position-relative w-100">
      <div class="privilege-step">
        <step-navbar
          :step-active="stepActive"
          :tab-list="['Main Category', 'Sub Category']"
        />
      </div>
      <div class="privilege-tab">
        <div class="row">
          <div class="col-12">
            <div>
              <b-tabs
                v-model="stepActive"
                class="custom-tab"
              >
                <b-tab
                  :title="'Category Detail'"
                  :title-link-class="['font-medium-5']"
                  lazy
                >
                  <privilege-category-detail
                    @onCreateSuccess="checkFormCreateOrEdit"
                    @onNextStep="stepActive++"
                  />
                </b-tab>
                <b-tab
                  :title="'Sub Category'"
                  :title-link-class="[
                    'font-medium-5',
                    { 'bypass text-muted': CategoryId == 0 },
                  ]"
                  lazy
                >
                  <privilege-sub-category
                    :category-id="CategoryId"
                    @onPreviousStep="stepActive--"
                  />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, reactive, computed, onBeforeMount,
} from '@vue/composition-api'
import usePrivilegeCategoryInfo from './hooks/usePrivilegeCategoryInfo'
import PrivilegeCategoryDetail from './components/PrivilegeCategoryDetail.vue'
import PrivilegeSubCategory from './components/PrivilegeSubCategory.vue'

export default {
  components: {
    PrivilegeCategoryDetail,
    PrivilegeSubCategory,
  },
  setup() {
    const {
      modeEditor,
      CategoryId,
      stepActive,
      checkFormCreateOrEdit,
    } = usePrivilegeCategoryInfo()

    return {
      modeEditor,
      CategoryId,
      stepActive,
      checkFormCreateOrEdit,
    }
  },
}
</script>

<style scope>
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/privilege/privilege-information.css';
@import '~@/assets/css/pages/privilege/privilege-form.css';
@import '~@/assets/css/override-styles/progress-nav.css';
</style>
